/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-03-26",
    versionChannel: "nightly",
    buildDate: "2025-03-26T00:06:52.223Z",
    commitHash: "ee37f4e6f987b1f579ee68f3605a40e56745d67a",
};
